import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import styles from './TaxExtensionProgressionActions.sass'

interface Props {
  vm: JobProgressionViewModel

  // If an outside button of this component is primary, use this prop to prevent having two primary buttons.
  isSecondary?: boolean
}

export default observer(function TaxExtensionProgressionActions({
  vm,
  isSecondary,
}: Props) {
  return (
    <CardContent>
      <div className={styles.cardContainer}>
        {vm.isPersonalExtensionAvailable && (
          <Button
            type={isSecondary ? 'secondary' : 'primary'}
            size="wide-slim"
            onClick={() => vm.answerJobPersonalExtensionInProgress()}
            dataTest="job-progression-start-personal-extension-button"
          >
            Begin Personal Extension
          </Button>
        )}

        {vm.isBusinessExtensionAvailable && (
          <Button
            type={
              isSecondary || vm.isPersonalExtensionAvailable
                ? 'secondary'
                : 'primary'
            }
            size="wide-slim"
            onClick={() => vm.answerJobBusinessExtensionInProgress()}
            dataTest="job-progression-start-business-extension-button"
          >
            Begin Business Extension
          </Button>
        )}

        {vm.isOutsourcingExtensionAvailable && (
          <Button
            type={isSecondary ? 'secondary' : 'primary'}
            size="wide-slim"
            onClick={() => vm.answerJobOutsourcingExtensionInProgress()}
            dataTest="job-progression-start-outsourcing-extension-button"
          >
            Place Job On Extension
          </Button>
        )}
      </div>
    </CardContent>
  )
})
